/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { OpenAIEffort } from '../enums/open-ai-effort';
import { OpenAIModels } from '../enums/open-ai-models';
export class PromptEntity extends Entity {
  createdAt: string | null = null;
  description: string | null = null;
  effort: OpenAIEffort | null = null;
  id: string = '';
  key: string | null = null;
  model: OpenAIModels | null = null;
  prompt: string | null = null;
  updatedAt: string | null = null;
  updatedBy: string | null = null;
  static override key = 'Prompt';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Prompt' in input
    ) {
      const { Prompt: wrapped, ...rest } = input as {
        Prompt: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}